import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../common/material'

export const useHeaderStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: theme.custom.headerHeight,
        backgroundColor: theme.custom.colors.oxfordBlue,
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        justifyContent: 'space-between',
        zIndex: 1,
        overflow: 'hidden'
    },
    appLogoContainer: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: theme.custom.headerHeight
    },
    logo: {
        display: 'inline-flex',
        position: 'relative',
        top: 0,
        left: 0,
        height: 60,
        marginLeft: getPixelInREM(12),
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        height: '50%'
    },
    actions: {
        display: 'inline-flex',
        alignItems: 'center',
        height: theme.custom.headerHeight,
        marginRight: getPixelInREM(16)
    }
}))
